import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "m-12" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Request Backup ")
const _hoisted_4 = { class: "m-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Request Backup")
const _hoisted_6 = { class: "m-12" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Request Import ")
const _hoisted_8 = { class: "m-4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Request Import")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_component = _resolveComponent("button-component")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("input", {
            class: "p-2 py-1 pl-2 mb-4 text-sm border rounded focus:outline-none bg-primary-dark",
            type: "text",
            placeholder: "Backup Name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.backupPath = $event))
          }, null, 512), [
            [_vModelText, _ctx.backupPath]
          ]),
          _createVNode(_component_button_component, { onClick: _ctx.requestBackup }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _withDirectives(_createVNode("input", {
            class: "p-2 py-1 pl-2 mb-4 text-sm border rounded focus:outline-none bg-primary-dark",
            type: "text",
            placeholder: "Backup Name",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.backupPath = $event))
          }, null, 512), [
            [_vModelText, _ctx.backupPath]
          ]),
          _withDirectives(_createVNode("input", {
            class: "p-2 py-1 pl-2 mb-4 text-sm border rounded focus:outline-none bg-primary-dark",
            type: "text",
            placeholder: "Import Name",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.importPath = $event))
          }, null, 512), [
            [_vModelText, _ctx.importPath]
          ]),
          _createVNode(_component_button_component, { onClick: _ctx.requestRestore }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}